import {CompilationTargetId} from "../types/CompilationTargetId";
import {CompilationTargets} from "../types/CompilationTargets";

export const compilationTargets: CompilationTargets = {
  [CompilationTargetId.all]: {
    fallbacks: [
      CompilationTargetId.other
    ]
  },
  [CompilationTargetId.browser]: {
    extension: "js",
    fallbacks: [
      CompilationTargetId.es6,
      CompilationTargetId.all,
      CompilationTargetId.other
    ]
  },
  [CompilationTargetId.es6]: {
    extension: "js",
    fallbacks: [
      CompilationTargetId.all,
      CompilationTargetId.other
    ]
  },
  [CompilationTargetId.node]: {
    extension: "js",
    fallbacks: [
      CompilationTargetId.es6,
      CompilationTargetId.all,
      CompilationTargetId.other
    ]
  },
  [CompilationTargetId.other]: {
    fallbacks: [
      CompilationTargetId.all
    ]
  },
  [CompilationTargetId.python3]: {
    extension: "py3",
    fallbacks: [
      CompilationTargetId.all,
      CompilationTargetId.other
    ]
  }
};
